const UNIVERSAL = {
  // BASEURL: "http://localhost:7001/",
  // BASEURL: "https://testdrivebackend-64qjz2tr4a-el.a.run.app/",
  BASEURL: "https://tdrivebackend-574807580639.asia-south1.run.app/",
  // BASEURL: "https://2f67-2409-4089-1207-edf6-d950-24e6-1251-e119.ngrok-free.app/",
};
export default UNIVERSAL;
